import { Box, Fade, Typography, useTheme } from '@mui/material';
import React from 'react';

const AskAiHeader = () => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				maxWidth: 720,
				mx: 'auto',
			}}
		>
			<Fade in={true} timeout={2000}>
				<Typography
					sx={{
						fontSize: { xs: '1.5rem', md: '1.85rem' },
						fontWeight: 700,
						mb: 1,
					}}
				>
					Ask <span style={{ color: theme.palette.folioPurple }}>Folio AI</span> to analyse,
					draft, and explain.
				</Typography>
			</Fade>

			<Fade in={true} timeout={3000}>
				<Typography sx={{ color: theme.palette.text.secondary, lineHeight: 1.7 }}>
					Use it for broker briefings, recent correspondence summaries, policy context,
					missing information checks, and client-ready drafting.
				</Typography>
			</Fade>
		</Box>
	);
};

export default AskAiHeader;
